module.exports = __webpack_public_path__ + "fonts/Barlow-SemiBold.d8252de4.eot";